import { formatDateToLocale } from "@/common/helpers/format-date";
import { Calendar, Fingerprint } from "lucide-react";
import { useTranslation } from "react-i18next";

interface SystemInfoSubComponentProps {
  uuid?: string;
  v1Id?: string | number | null;
  createdAt?: string;
  updatedAt?: string;
}

export function SystemInfoSubComponent({ uuid, v1Id, createdAt, updatedAt }: SystemInfoSubComponentProps) {
  const { t } = useTranslation("common");

  return (
    <>
      {(uuid || v1Id) && (
        <div className="space-y-2">
          <h4 className="text-foreground flex items-center gap-2 text-sm font-semibold">
            <Fingerprint className="text-primary h-4 w-4" />
            {t("System")}
          </h4>
          <div className="space-y-1 text-xs">
            {uuid && (
              <div className="flex justify-between gap-4">
                <span className="text-muted-foreground">{t("UUID")}:</span>
                <span className="font-mono font-medium">{uuid}</span>
              </div>
            )}
            {v1Id && (
              <div className="flex justify-between gap-4">
                <span className="text-muted-foreground">{t("masterdata:V1ID")}:</span>
                <span className="font-mono font-medium">{v1Id}</span>
              </div>
            )}
          </div>
        </div>
      )}

      {(createdAt || updatedAt) && (
        <div className="space-y-2">
          <h4 className="text-foreground flex items-center gap-2 text-sm font-semibold">
            <Calendar className="text-primary h-4 w-4" />
            {t("Timestamps")}
          </h4>
          <div className="space-y-1 text-xs">
            {createdAt && (
              <div className="flex justify-between gap-4">
                <span className="text-muted-foreground">{t("CreatedAt")}:</span>
                <span className="font-medium">{formatDateToLocale(createdAt)}</span>
              </div>
            )}
            {updatedAt && (
              <div className="flex justify-between gap-4">
                <span className="text-muted-foreground">{t("UpdatedAt")}:</span>
                <span className="font-medium">{formatDateToLocale(updatedAt)}</span>
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
}
